var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNoSound(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.43583 0.31958L0.31958 1.43583L3.77125 4.8875L3.54166 5.125H0.374997V9.875H3.54166L7.5 13.8333V8.61625L10.8092 11.9254C10.2946 12.3133 9.71666 12.6221 9.08333 12.8042V14.435C10.1442 14.1975 11.1179 13.7067 11.9412 13.0496L13.5642 14.6725L14.6804 13.5562L1.43583 0.31958ZM13.0417 7.5C13.0417 8.14916 12.9229 8.77458 12.7171 9.3525L13.9283 10.5637C14.3717 9.6375 14.625 8.60041 14.625 7.5C14.625 4.11166 12.2579 1.2775 9.08333 0.55708V2.18791C11.3712 2.86875 13.0417 4.99041 13.0417 7.5ZM7.5 1.16666L6.01166 2.655L7.5 4.14333V1.16666ZM11.0625 7.5C11.0625 6.09875 10.255 4.89541 9.08333 4.30958V5.72666L11.0467 7.69C11.0546 7.62666 11.0625 7.56333 11.0625 7.5Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoSound);
export default __webpack_public_path__ + "static/media/no_sound.6e1c2a4b009c7323808495d676de3bda.svg";
export { ForwardRef as ReactComponent };